import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {PaymentType} from "../components/create-payment/payment-type.model";
import {QuickActions} from "../../messages-center/models/enums/quick-actions.enum";
import {BFPaymentTypes} from "../../business-framework/messages/models/enums/bf-payment-types.enum";
import {NavigationService} from "../../core/navigation/services/navigation.service";

@Injectable({
  providedIn: 'root'
})
export class QuickActionManagerService {

  public fxWiredToggleChange$:BehaviorSubject<boolean> = new BehaviorSubject(false);
  paymentTypeChange$:BehaviorSubject<PaymentType> = new BehaviorSubject(null);
  paymentTypeChangeObservable = this.paymentTypeChange$.asObservable()
  fxToggleWiredChangeObservable = this.fxWiredToggleChange$.asObservable()

  constructor(private navigationService: NavigationService) { }

  protected getSiteMapEvent(action): string{
    switch (action){
      case QuickActions.CREATE_CUSTOMER_PAYMENT_TEMPLATE:
        return 'eventCreateCustomerMessageTemplate';
      case QuickActions.CREATE_REQUEST_FOR_PAYMENT:
        return 'eventCreateRequestForPayment'
      case QuickActions.CREATE_REQUEST_FOR_PAYMENT_TEMPLATE:
        return 'eventCreateRequestForPaymentTemplate'
      default:
      case QuickActions.CREATE_FX_PAYMENT:
      case QuickActions.CREATE_CUSTOMER_PAYMENT:
      case QuickActions.CREATE_PAYMENT:
        return 'eventCreateCustomerMessage'
    }
  }

   getPaymentTypeByQuickAction(action: QuickActions, isSingleOffice = false): PaymentType{
   if(action== QuickActions.CREATE_FX_PAYMENT && isSingleOffice){
     return this.getPaymentTypeForFXSingleOffice()
   }
    let paymentTypes = this.navigationService.getCreatePaymentItems().filter((item: PaymentType) => {
      return item.event !== BFPaymentTypes.PACS_008_US_INTERNATIONAL && item.event !== BFPaymentTypes.PACS_008_US_INTERNATIONAL_FX;
    });
    let actionEvent = this.getSiteMapEvent(action);
    return  paymentTypes.filter(item=>item.event === actionEvent)[0]
  }

  updateCreatePaymentSelectedType(action: QuickActions){
    let paymentType = this.getPaymentTypeByQuickAction(action);
    this.paymentTypeChange$.next(paymentType)
  }

  protected getPaymentTypeForFXSingleOffice(): PaymentType{
    return {
      event: 'eventCreateFxCustomerMessage', action:'', alias:'', id:''
    };
  }
}
